export const VIEW_LIMIT = 3;
export const SESSION_STORAGE_KEY = 'tradePromo';

export const TRADE_WELCOME_PROMO_CODE = 'TRADEWELCOME';
export const TRADE_FIRST_WELCOME_PROMO_CODE = 'TRADE1STWELCOME';
export const TRADE_PROMO_CODES = [];
export const EXPIRING_TRADE_PROMO_CODES = [
    TRADE_WELCOME_PROMO_CODE,
    TRADE_FIRST_WELCOME_PROMO_CODE,
];

export const MODAL_IDS = {};
export const EXPIRING_MODAL_IDS = {
    [TRADE_WELCOME_PROMO_CODE]: 'tradeWelcomeExpiringPromo',
    [TRADE_FIRST_WELCOME_PROMO_CODE]: 'trade1stWelcomeExpiringPromo',
};
